import React from 'react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

/**
 * Componente de loading spinner reutilizável
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
}) => {
  return (
    <div className={`flex items-center justify-center p-8 ${className}`}>
      <div
        className={`animate-spin rounded-full border-b-2 border-primary-600 ${sizeClasses[size]}`}
        role='status'
        aria-label='Carregando'
      >
        <span className='sr-only'>Carregando...</span>
      </div>
    </div>
  );
};

export interface SkeletonProps {
  className?: string;
  height?: string;
  width?: string;
}

/**
 * Componente Skeleton para estados de loading
 */
export const Skeleton: React.FC<SkeletonProps> = ({
  className = '',
  height = 'h-4',
  width = 'w-full',
}) => {
  return (
    <div
      className={`animate-pulse bg-gray-200 rounded ${height} ${width} ${className}`}
      aria-hidden='true'
    />
  );
};

/**
 * Skeleton específico para página inteira
 */
export const PageSkeleton: React.FC = () => {
  return (
    <div className='p-8 space-y-4'>
      <Skeleton height='h-8' width='w-1/3' />
      <Skeleton height='h-64' />
      <div className='space-y-2'>
        <Skeleton height='h-4' />
        <Skeleton height='h-4' width='w-5/6' />
        <Skeleton height='h-4' width='w-4/6' />
      </div>
    </div>
  );
};
